namespace Ir.Components.ReportDesigner.ReportDesigner {

    let reportDesignerPopover: IReportDesignerPopover = null;
    export function showEditor(tabOrWidget: ITabOrWidget, openAdmin: IOpenAdmin = null) {
        if (reportDesignerPopover == null) {
            let $popover = $(`<report-designer params="callback: getComponent, openAsPopup: openAsPopup"></report-designer>`);
            $popover.appendTo('body');
            ko.applyBindings({
                getComponent(component: IReportDesignerPopover) {
                    reportDesignerPopover = component;
                    reportDesignerPopover.show(tabOrWidget, openAdmin);
                },
                openAsPopup: true,
            }, $popover[0]);
        }
        else {
            reportDesignerPopover.show(tabOrWidget, openAdmin);
        }
    }

    export function isReportDesignerOpen() {
        return reportDesignerPopover != null;
    }

    export interface IReportDesignerPopover {
        show(tabOrWidget: ITabOrWidget, openAdmin: IOpenAdmin);
    }

    export interface IViewModel {
        popoverOptions: DevExpress.ui.dxPopup.Properties;
        fields: KnockoutObservableArray<ReportField | MetricField>;
        groups: KnockoutObservableArray<ReportField>;
        metrics: KnockoutObservableArray<MetricField>;
        metricsEnabledOnFields: KnockoutObservable<boolean>;
        metricFieldsVisible: KnockoutObservable<boolean>;
        aceptMetrics: KnockoutObservable<boolean>;
        notAceptMetrics: KnockoutObservable<boolean>;
        widgetType: KnockoutObservable<WidgetType>;
        reportConfig: KnockoutObservable<ReportConfig>;
        comparisonFilters: KnockoutObservableArray<ComparisonFilter>;
        metricArray: KnockoutObservable<KnockoutObservableArray<MetricField>>;
        customAnalyzeByName: KnockoutObservable<string>;
        customGroupByName: KnockoutObservable<string>;
        includeAllMetrics: KnockoutObservable<boolean>;
        showCustomNames: KnockoutObservable<boolean>;

        fieldsParams: Ir.Components.ReportDesigner.ReportDesignerFieldList.IParams;
        groupsParams: Ir.Components.ReportDesigner.ReportDesignerFieldList.IParams;
        metricsParams: Ir.Components.ReportDesigner.ReportDesignerFieldList.IParams;
        comparisonFilterParams: Ir.Components.ReportDesigner.ComparisonFilterList.IParams;

        customAnalyzeByNameConfig: DevExpress.ui.dxTextBox.Properties;
        customGroupByNameConfig: DevExpress.ui.dxTextBox.Properties;
        allMetricSwitchConfig: DevExpress.ui.dxSwitch.Properties;

        allowDuplicatedNames: boolean;
        groupSectionName: KnockoutComputed<string>;
        fieldsSectionName: KnockoutComputed<string>;
        metricsSectionName: KnockoutComputed<string>;

        openAsPopup: boolean

        saveButtonOptions: DevExpress.ui.dxButton.Properties;
        cancelButtonOptions: DevExpress.ui.dxButton.Properties;

        dispose: Function;

        openJustOneMappingFields: KnockoutObservable<boolean>;
        addField: (item) => void;
        addGroup: (item) => void;
        addMetric: (item) => void;

        openingByAdmin: IOpenAdmin;
    }

    export interface IOpenAdmin {
        reportId: number;
        mappingId: number;
        onSave: (reportConfig: ReportConfig) => void;
        onCancel: () => void;
    }
    interface IParams {
        callback(component: IReportDesignerPopover);
        openAsPopup: boolean;        
    }

    let tabOrWidget: ITabOrWidget;

    //Used to call some functions, it may change later
    let lastSelfOpeningTab: IViewModel;

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {

        let self = this;

        if (!params.openAsPopup) {
            lastSelfOpeningTab = self;
        }

        self.openingByAdmin = null;
        self.showCustomNames = ko.observable(true);
        let popupComponent: DevExpress.ui.dxPopup;

        self.fields = ko.observableArray();
        self.groups = ko.observableArray();
        self.metrics = ko.observableArray();
        self.comparisonFilters = ko.observableArray();
        self.metricArray = ko.observable(ko.observableArray([]));
        self.widgetType = ko.observable();
        self.reportConfig = ko.observable();

        self.metricsEnabledOnFields = ko.observable(true);
        self.metricFieldsVisible = ko.observable(false);
        self.aceptMetrics = ko.observable(true);
        self.notAceptMetrics = ko.observable(false);
        self.customAnalyzeByName = ko.observable();
        self.customGroupByName = ko.observable();
        self.includeAllMetrics = ko.observable(false);
        self.openJustOneMappingFields = ko.observable(false);

        //Not allowing duplicated names until we review this
        self.allowDuplicatedNames = false;

        self.groupSectionName = ko.computed(function (this: KnockoutObservable<ReportConfig>) {
            return this()?.reportType() === ReportTypeEnum.Pivot ? "Columns (Pivot On)" : "Group";
        }, self.reportConfig);
        self.fieldsSectionName = ko.computed(function (this: KnockoutObservable<ReportConfig>) {
            return this()?.reportType() === ReportTypeEnum.Chart ? 'X Axis' : 'Fields';
        }, self.reportConfig);
        self.metricsSectionName = ko.computed(function (this: KnockoutObservable<ReportConfig>) {
            return this()?.reportType() === ReportTypeEnum.Chart ? 'Y Axis' : 'Metrics';
        }, self.reportConfig);

        self.openAsPopup = params.openAsPopup;

        if (self.openAsPopup) {     
            let $mappingPopover = null;
            self.popoverOptions = {
                height: "80%",
                width: 1200,
                title: "Report Designer",
                showCloseButton: false,
                dragEnabled: false,
                onHiding(e) {
                    Ir.Components.ReportDesigner.ComparisonFilterFilters.hide();
                    popoverMappingFieldsComponent?.hide();
                },                
                onHidden(e) {
                    setTimeout(function () {
                        //Remove report designer
                        if (popupComponent) {
                            popupComponent.dispose();
                            reportDesignerPopover = null;
                            componentInfo.element.remove();
                            $mappingPopover?.remove?.();
                        }
                    }, 50);
                },
                onInitialized(e) {
                    popupComponent = e.component;
                    if (params.callback) {
                        params.callback({
                            show(tabOrWidgetToEdit: ITabOrWidget, openAdmin: IOpenAdmin) {
                                tabOrWidget = tabOrWidgetToEdit;
                                self.openingByAdmin = openAdmin;
                                self.showCustomNames(self.openingByAdmin === null);
                                loadReport(self, tabOrWidget, popupComponent, function () {
                                    popupComponent.show();
                                });
                            },
                        } as IReportDesignerPopover);
                    }
                },
                toolbarItems: [
                    {
                        widget: 'dxButton',
                        toolbar: 'top',
                        location: 'after',
                        options: {
                            icon: "close",
                            hint: "Close",
                            stylingMode: 'text',
                            type: 'normal',
                            onClick() {
                                if (self.openingByAdmin) {
                                    self.openingByAdmin.onCancel();
                                }

                                popupComponent.hide();
                            },
                        },
                    },
                    {
                        locateInMenu: 'always',
                        widget: 'dxButton',
                        toolbar: 'top',
                        options: {
                            text: 'Undo Changes',
                            onClick() {
                                loadReport(self, tabOrWidget, popupComponent, function () {
                                    DevExpress.ui.notify({
                                        message: "Changes undone.",
                                        position: {
                                            my: 'center top',
                                            at: 'center top',
                                        },
                                    }, 'success', 3000);
                                });
                            },
                        },
                    },
                    // Used to test
                    // {
                    //     widget: 'dxButton',
                    //     toolbar: 'bottom',
                    //     location: 'before',
                    //     options: {
                    //         icon: 'save',
                    //         stylingMode: 'contained',
                    //         text: 'Validate',
                    //         onClick() {
                    //             Ir.Components.ReportDesigner.ComparisonFilterFilters.hide();
                    //             onChanged();
                    //         },
                    //     },
                    // }, 
                    {
                        widget: 'dxButton',
                        toolbar: 'bottom',
                        location: 'after',
                        options: {
                            icon: 'save',
                            stylingMode: 'contained',
                            type: 'default',
                            text: 'Save',
                            onClick() {
                                save(self, tabOrWidget, popupComponent)
                            },
                        },
                    },
                    {
                        widget: 'dxButton',
                        toolbar: 'bottom',
                        location: 'after',
                        options: {
                            icon: "undo",
                            text: 'Cancel',
                            stylingMode: 'outlined',
                            type: 'normal',
                            onClick() {
                                if (self.openingByAdmin) {
                                    self.openingByAdmin.onCancel();
                                }

                                popupComponent.hide();
                            },
                        },
                    }
                ],
                onShown(e) {
                    if (self.openJustOneMappingFields()) {
                        setTimeout(function () {
                            $mappingPopover = showMappingFields(e.component.content(), self);
                        }, 100);                        
                    }
                }
            };            
        }
        else {
            loadReport(self, workbook?.workbookConfig?.activeTabOrWidget?.(), undefined);

            tabOrWidget = workbook?.workbookConfig?.activeTabOrWidget?.();
            self.saveButtonOptions = {
                icon: 'check',
                stylingMode: 'contained',
                type: 'default',
                text: 'Apply',
                onClick() {
                    save(self, workbook?.workbookConfig?.activeTabOrWidget?.());
                }
            };
            self.cancelButtonOptions = {
                icon: "undo",
                text: 'Cancel',
                stylingMode: 'outlined',
                type: 'normal',
                onClick() {
                    Ir.Components.ReportDesigner.ComparisonFilterFilters.hide();
                    loadReport(self, workbook?.workbookConfig?.activeTabOrWidget?.(), undefined, function () {
                        DevExpress.ui.notify({
                            message: "Changes cancelled.",
                            position: {
                                my: 'center top',
                                at: 'center top',
                            },
                        }, 'success', 3000);
                    });
                }
            };
        }

        self.fieldsParams = {
            title: self.fieldsSectionName,
            fields: self.fields,
            aceptMetrics: self.metricsEnabledOnFields,
            aceptFields: true,
            widgetType: self.widgetType,
            reportConfig: self.reportConfig,
            onChanged(isSaving?: boolean) {
                onChanged(self, isSaving);
            },
            metricArray: self.metricArray,
            onAddFieldFromMapping: function (field: ReportField | MetricField) {
                onAddFieldFromMapping(self, field);
            },
            hasComparisonFilters: ko.computed(function() {
                return self.comparisonFilters().length > 0;
            }),
            groupFields: self.groups,
            openingAsPopup: self.openAsPopup,
            reportDesigner: self,
            getAddFieldsFunctions: function (onSelect: (item) => void) {
                self.addField = onSelect;
            },
            showAddButton: ko.computed(() => {
                return !self.openJustOneMappingFields();
            })
        };
        self.groupsParams = {
            title: self.groupSectionName,
            fields: self.groups,
            aceptMetrics: self.notAceptMetrics,
            aceptFields: true,
            widgetType: self.widgetType,
            reportConfig: self.reportConfig,
            onChanged(isSaving?: boolean) {
                onChanged(self, isSaving);
            },
            metricArray: self.metricArray,
            groupList: true,
            hasComparisonFilters: ko.computed(function() {
                //groups don't have metrics, so it shouldn't be used
                return false;
            }),
            groupFields: self.groups,
            openingAsPopup: self.openAsPopup,
            reportDesigner: self,
            getAddFieldsFunctions: function (onSelect: (item) => void) {
                self.addGroup = onSelect;
            },
            showAddButton: ko.computed(() => { return !self.openJustOneMappingFields(); })
        };
        self.metricsParams = {
            title: self.metricsSectionName,
            fields: self.metrics,
            aceptMetrics: self.aceptMetrics,
            aceptFields: false,
            widgetType: self.widgetType,
            reportConfig: self.reportConfig,
            onChanged(isSaving?: boolean) {
                onChanged(self, isSaving);
            },
            metricArray: self.metricArray,
            onAddFieldFromMapping: function(field: ReportField | MetricField) {
                onAddFieldFromMapping(self, field);
            },
            hasComparisonFilters: ko.computed(function() {
                return self.comparisonFilters().length > 0;
            }),
            groupFields: self.groups,
            openingAsPopup: self.openAsPopup,
            reportDesigner: self,
            getAddFieldsFunctions: function (onSelect: (item) => void) {
                self.addMetric = onSelect;
            },
            showAddButton: ko.computed(() => { return !self.openJustOneMappingFields(); })
        };

        self.comparisonFilterParams = {
            comparisonFilters: self.comparisonFilters,
            reportConfig: self.reportConfig,
            metricArray: self.metricArray,
            onChanged(isSaving?: boolean) {
                onChanged(self, isSaving);
            },
            widgetType: self.widgetType,
            reportDesigner: self
        };

        self.customAnalyzeByNameConfig = {
            value: self.customAnalyzeByName as any,
            width: 280,
            label: "Custom Name",
            labelMode: "static",
            height: 32,
            placeholder: "Automatic",
            hint: "Custom name for Analyze By",
            visible: self.showCustomNames as any
        };

        self.customGroupByNameConfig = {
            value: self.customGroupByName as any,
            width: 280,
            label: "Custom Name",
            labelMode: "static",
            height: 32,
            placeholder: "Automatic",
            hint: "Custom name for Group By",
            disabled: ko.computed(function () {
                return self.groups().length == 0;
            }) as any,
            visible: self.showCustomNames as any
        };

        self.allMetricSwitchConfig = {
            value: self.includeAllMetrics as any,
            disabled: ko.computed(function () {
                return self.comparisonFilters().length !== 0;
            }) as any,
            onValueChanged(e) {
                if (e.value) {
                    if (self.metricArray()().filter(x => x.isMetric).length > 0) {
                        var result = DevExpress.ui.dialog.confirm("Do you want to remove the current metrics and include All Metrics?", "Confirm including All Metrics");
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                self.metricArray().removeAll(self.metricArray()().filter(x => x.isMetric));
                            }
                            else {
                                self.includeAllMetrics(false);
                            }
                        });
                    }
                }
            }
        };

        self.dispose = function () {
            lastSelfOpeningTab = null;
        };
    }

    function save(self: IViewModel, tabOrWidget: ITabOrWidget, popupComponent: DevExpress.ui.dxPopup = undefined) {
        if (onChanged(self, true)) {
            Ir.Components.ReportDesigner.ComparisonFilterFilters.hide();

            self.reportConfig().includeAllMetrics(self.includeAllMetrics());
            self.reportConfig().customAnalyzeByName(self.customAnalyzeByName());
            self.reportConfig().customGroupByName(self.customGroupByName());

            //It is not working correctly for the group 
            if (self.reportConfig().groupReportId() === 0 && self.groups().length > 0) {
                self.reportConfig().groupReportId(-1);
            }
            else {
                if (self.reportConfig().groupReportId() > 0) {
                    if (self.groups().length === 0) {
                        self.reportConfig().groupReportId(0);
                    }
                    else {
                        //Need to validate if the fields are the same as the report template
                        //Validation is being done at backend
                        //validateTemplate(tabOrWidget, self.reportConfig().groupReportId, self.groups);
                    }
                }
            }

            if (self.reportConfig().templateId() > 0) {
                //Need to validate if the fields are the same as the report template
                //Validation is being done at backend
                //validateTemplate(tabOrWidget, self.reportConfig().templateId, self.fields);
            }

            let showMessage = () => {
                DevExpress.ui.notify({
                    message: "Changes saved.",
                    position: {
                        my: 'center top',
                        at: 'center top',
                    },
                }, 'success', 3000);
            }

            if (self.reportConfig().columnsWidthType() === ColumnsWidthTypeEnum.Percentage) {
                let fields = [...self.reportConfig().fields(), ...self.reportConfig().metricFields()];
                let sumPercentage = fields.reduce((total, field) => total + (field.width() ?? 0), 0);
                if (fields.length > 0 && sumPercentage < 100) {
                    let diffAdd = (100 - sumPercentage) / fields.length;
                    for (const field of fields) {
                        field.width((field.width() ?? 0) + diffAdd);
                    }
                }
            }

            if (self.openingByAdmin) {
                self.openingByAdmin.onSave(self.reportConfig());

                if (popupComponent) {
                    popupComponent.hide();
                }

                showMessage();
            }
            else {
                let widget = tabOrWidget.drilldownManager.isDrilldown ? tabOrWidget.drilldownManager.getActiveWidget() : tabOrWidget.widget;

                let drilldownId: number = null;

                if (tabOrWidget.drilldownManager.isDrilldown) {
                    (widget.itemConfig as ReportConfig).updateAfterReportDesigner(self.reportConfig());
                    drilldownId = tabOrWidget.drilldownManager.activeDrilldownId;
                }
                else {
                    (widget.itemConfig as ReportConfig).updateAfterReportDesigner(self.reportConfig());
                }

                widget.saveSettings(function (data) {
                    (widget.itemConfig as ReportConfig).updateReportAfterSaving(data);

                    if (!tabOrWidget.drilldownManager.isDrilldown) {
                        Ir.Components.Workbook.ToolBar.ReportToolBar.repaintAnalyzeByGroupBy?.();
                    }

                    if (popupComponent) {
                        Ir.Components.Workbook.WorkbookSideTabs.refresh();
                        popupComponent.hide();
                    }

                    showMessage();

                    if (tabOrWidget) {
                        if (tabOrWidget.drilldownManager.isDrilldown) {
                            tabOrWidget.drilldownManager.refresh();
                        }
                        else {
                            tabOrWidget.refresh();
                        }
                    }
                }, drilldownId);
            }
        }
    }

    function validateTemplate(tabOrWidget: ITabOrWidget, templateId: KnockoutObservable<number>, fields: KnockoutObservableArray<ReportField>) {
        let submitObject = tabOrWidget.getBaseSubmitObject();
        submitObject.templateId = templateId();

        let successFunction = function (data) {
            let custom = true;
            if (data.fields) {
                let templateFields = data.fields as Array<ReportField>;
                custom = false;
                let reportFields = fields().filter(x => !x.isMetric);
                for(let templateField of templateFields.filter(x => !x.isMetric)) {
                    if(!reportFields.find(x => !x.isMetric && x.field === templateField.field)) {
                        custom = true;
                        break;
                    }
                }
            }
            if (custom) {
                templateId(-1);
            }
        };

        let errorFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get fields";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
            templateId(-1);
        };

        irGlobal.requestServer({
            url: urlConfigs.designer + "GetTemplatesFields",
            data: submitObject,
            successFunction: successFunction,
            failureFunction: errorFunction,
            async: false,
        } as RequestServerParams);
    }

    export function reload(tabOrWidget: ITabOrWidget) {
        if (lastSelfOpeningTab) {//if visible
            loadReport(lastSelfOpeningTab, tabOrWidget, undefined);
        }
    }
    function loadReport(self: IViewModel, tabOrWidget: ITabOrWidget, popupComponent: DevExpress.ui.dxPopup, successCallback: Function = undefined) {

        let submitObject = {} as any;
        let url = "";
        if (self.openingByAdmin) {
            submitObject.mappingId = self.openingByAdmin.mappingId;
            submitObject.reportTemplateId = self.openingByAdmin.reportId;
            url = `${urlConfigs.reportTemplate}GetConfig`;
        }
        else {
            submitObject = tabOrWidget.getBaseSubmitObject();
            url = `${urlConfigs.workBook}GetConfig`;

            if (tabOrWidget) {
                submitObject.drilldownId = tabOrWidget.drilldownManager.activeDrilldownId;
            }
        }

        let successFunction = function (data) {
            //Get a new instace from server because the user can cancel the edition
            let reportConfig = new ReportConfig(data, self.openingByAdmin !== null);

            let currentWidget = tabOrWidget?.drilldownManager?.isDrilldown ? tabOrWidget.drilldownManager.getActiveWidget() : tabOrWidget?.widget;
            self.widgetType(currentWidget?.widgetType ?? reportTypeToWidgetType(reportConfig.reportType()));

            self.reportConfig(reportConfig);
            self.fields(reportConfig.fields());
            self.groups(reportConfig.groupReportFields()[0]?.fields() ?? []);
            self.metrics(reportConfig.metricFields() ?? []);
            self.metricsEnabledOnFields(reportConfig.reportType() === ReportTypeEnum.Analysis);
            self.metricFieldsVisible(reportConfig.reportType() !== ReportTypeEnum.Analysis);
            self.comparisonFilters(reportConfig.comparisonFilters());
            for (let comparisonFilter of self.comparisonFilters()) {
                for (let filter of comparisonFilter.filters()) {
                    filter.isComparisonFilter(true);
                }
            }
            self.includeAllMetrics(reportConfig.includeAllMetrics());
            self.customAnalyzeByName(reportConfig.customAnalyzeByName());
            self.customGroupByName(reportConfig.customGroupByName());

            let isReport = self.reportConfig().reportType() === ReportTypeEnum.Analysis;
            self.metricArray(isReport ? self.fields as KnockoutObservableArray<MetricField> : self.metrics);

            let width = isReport ? 900 : 1200;
            if (self.openAsPopup) {
                if ($(window).width() > (width + 500)) {
                    self.openJustOneMappingFields(true);
                }
                else {
                    self.openJustOneMappingFields(false);
                    popoverMappingFieldsComponent?.hide?.();
                }
            }

            popupComponent?.option("width", width);
            prepareDesigner(self);
            if (successCallback) {
                successCallback();
            }
        };

        let errorFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get the Report";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.updateFromServer({},
            url,
            submitObject,
            successFunction,
            errorFunction,
            true,
            "POST");
    }

    function onAddFieldFromMapping(self: IViewModel, field: MetricField | ReportField) {
        if(field.isMetric && self.comparisonFilters().length > 0) {
            Ir.Components.ReportDesigner.ComparisonFilterList.addComparisonMetrics(field as MetricField, self.widgetType(), self.metricArray(), self.comparisonFilters);
        }
    }

    function onChanged(self: IViewModel, isSaving?: boolean) {

        if (self.includeAllMetrics() && self.comparisonFilters().length > 0) {
            self.includeAllMetrics(false);
            DevExpress.ui.notify({
                message: "Can't use comparison filters with Include All Metrics. Turning off the include All Metrics.",
                position: {
                    my: 'center top',
                    at: 'center top',
                },
            }, 'warning', 3000);
        }

        if (self.includeAllMetrics() && self.metricArray()().filter(x => x.isMetric).length > 0) {
            self.includeAllMetrics(false);
            DevExpress.ui.notify({
                message: "Metrics were included, turning off the include All Metrics.",
                position: {
                    my: 'center top',
                    at: 'center top',
                },
            }, 'warning', 3000);
        }


        var validation = validateDesigner(self);
        if (validation.isValid && self.metricArray()().filter(x => x.isMetric).length === 0 && self.comparisonFilters().length > 0) {
            validation.isValid = false;
            validation.invalidMessage = "It is necessary to have at least one metric when there are comparison filters.";
        }

        if (isSaving && !validation.isValid) {
            DevExpress.ui.notify({
                message: "This design is not valid. " + validation.invalidMessage,
                position: {
                    my: 'center top',
                    at: 'center top',
                },
            }, 'error', 3000);
            return false;
        }
        else {
            return true;
        }
    };

    function validateDesigner(self: IViewModel) {
        var output = {
            isValid: true,
            invalidMessage: ""
        };

        let reportConfig = self.reportConfig();
        let reportType = reportConfig.reportType();
        let fields = self.fields();
        let groupFields = self.groups();
        let metrics = self.metrics();
        let comparisonFilters = self.comparisonFilters();

        //Report or Pivot
        if (reportType !== ReportTypeEnum.Chart) {
            if (fields.length > 0) {
                var hasNonMetric = false;
                var hasGroupBy = false;
                for (let reportField of fields) {
                    if (!reportField.isMetric)
                        hasNonMetric = true;

                    if (reportField.groupingType() === GroupingTypeEnum.GROUP_BY)
                        hasGroupBy = true;
                }
                if (!hasNonMetric) {
                    output.invalidMessage = "It is necessary to have at least one non-metric field.";
                    output.isValid = false;
                }
                else if (!hasGroupBy && reportConfig.isAggregative()) {
                    output.invalidMessage = "It is necessary to have at least one non-metric field with 'Group By' Operation.";
                    output.isValid = false;
                }
            }
            else {
                output.invalidMessage = "It is necessary to have rows definition.";
                output.isValid = false;
            }

            //Pivot
            if (output.isValid && reportType === ReportTypeEnum.Pivot) {
                if (!tabOrWidget.drilldownManager.isDrilldown) {
                    if (groupFields.length === 0) {
                        output.invalidMessage = "It is necessary one non-metric field on Columns(Pivot On).";
                        output.isValid = false;
                    }
                    else {
                        hasGroupBy = false;
                        for (let reportField of groupFields) {
                            if (reportField.groupingType() === GroupingTypeEnum.GROUP_BY)
                                hasGroupBy = true;
                        }
                        if (!hasGroupBy) {
                            output.invalidMessage = "It is necessary to have at least one non-metric field with 'Group By' Operation on Columns(Pivot On).";
                            output.isValid = false;
                        }
                    }
                }

                if (output.isValid && metrics.length === 0 && !self.includeAllMetrics()) {
                    output.invalidMessage = "It is necessary to have at least one metric.";
                    output.isValid = false;
                }
            }
        }
        //Chart
        else {
            if (fields.length === 0) {
                output.invalidMessage = "It is necessary to have at least one non-metric field on X axis.";
                output.isValid = false;
                return output;
            }

            if (metrics.length === 0 && !self.includeAllMetrics()) {
                output.invalidMessage = "It is necessary to have at least one metric on Y axis.";
                output.isValid = false;
                return output;
            }

            hasGroupBy = false;
            for (let reportField of fields) {
                if (reportField.groupingType() === GroupingTypeEnum.GROUP_BY)
                    hasGroupBy = true;
            }
            if (!hasGroupBy && reportConfig.isAggregative) {
                output.invalidMessage = "It is necessary to have at least one non-metric field with 'Group By' Operation on X-Axis.";
                output.isValid = false;
                return output;
            }

            if (reportConfig.chartDefinition.chartType() === ChartType.Bubble && metrics.length < 3 && metrics.find(function (x) { return x.id() === allMetricName }) === undefined) {
                output.invalidMessage = "It is necessary at least 3 metrics for a Bubble Chart.";
                output.isValid = false;
            }

            if (reportConfig.chartDefinition.chartType() === ChartType.Scatter && metrics.length < 2 && metrics.find(function (x) { return x.id() === allMetricName }) === undefined) {
                output.invalidMessage = "It is necessary at least 2 metrics for a Scatter Chart.";
                output.isValid = false;
            }
        }

        if (output.isValid) {
            let rows = irGlobal.groupBy(fields.filter(function (x) { return !x.isMetric; }), 'groupId', true);
            let groups = irGlobal.groupBy(groupFields.filter(function (x) { return !x.isMetric; }), 'groupId', true);

            var checkVisibleField = function (array, source, eachLevelMessage) {
                for (const property in array) {
                    if (array[property].filter(function (x) { return x.visible(); }).length === 0) {
                        output.isValid = false;
                        output.invalidMessage = `${source} It is necessary to have at least one visible non-metric field ${(eachLevelMessage ? " on each level" : "")}.`;
                        break;
                    }
                }
            }

            checkVisibleField(rows, reportType === ReportTypeEnum.Pivot ? "Rows:" : reportType === ReportTypeEnum.Chart ? "X Axis: " : "Columns:", reportType === ReportTypeEnum.Pivot ? true : false);
            checkVisibleField(groups, reportType === ReportTypeEnum.Pivot ? "Columns:" : "Groups:", reportType === ReportTypeEnum.Chart ? false : true);
        }

        if (!output.isValid)
            return output;

        if (groupFields.length > 0) {
            hasGroupBy = false;
            for (let reportField of groupFields) {
                if (reportField.groupingType() === GroupingTypeEnum.GROUP_BY)
                    hasGroupBy = true;
            }
            if (!hasGroupBy) {
                output.invalidMessage = `It is necessary to have at least one non-metric field with 'Group By' Operation on ${self.groupSectionName()}.`;
                output.isValid = false;
                return output;
            }
        }

        output.isValid = validateFields(self);

        if (output.isValid && !reportConfig.isAggregative && comparisonFilters.length > 0) {
            output.isValid = false;
            output.invalidMessage = "It is not allowed to have Comparison Filter in a non-aggregated report.";
        }

        if (output.isValid && comparisonFilters.length > 0) {
            if (comparisonFilters.filter(function (x) { return !x.name(); }).length > 0) {
                output.isValid = false;
                output.invalidMessage = "Comparison Filter name cannot be blank.";
            }

            if (output.isValid) {
                let groups = irGlobal.groupBy(comparisonFilters, 'name', true);
                for (const property in groups) {
                    if (groups[property].length > 1) {
                        output.isValid = false;
                        output.invalidMessage = "Duplicated comparison filter name.";
                        break;
                    }
                }
            }
        }

        return output;
    }
    export function validateFieldsForExpression(self: Ir.Components.ReportDesigner.ReportDesigner.IViewModel) {
        validateFields(self);
    }
    function validateFields(self: IViewModel) {
        var output = true;
        if (!validateFieldsArray(self, self.fields))
            output = false;
        if (!validateFieldsArray(self, self.groups))
            output = false;
        if (!validateFieldsArray(self, self.metrics))
            output = false;
        return output;
    }

    function validateFieldsArray(self: IViewModel, reportFields: KnockoutObservableArray<ReportField | MetricField>) {
        //Test duplicate non-metrics
        var output = true;

        for (let reportField of reportFields()) {
            reportField.designerVM.isValid(true);
            reportField.designerVM.invalidMessage("");
        }

        for (let i = 0; i < reportFields().length; i++) {
            let reportField = reportFields()[i];
            var duplicated = false;
            if (reportField.designerVM.isValid()) {
                for (var j = i + 1; j < reportFields().length; j++) {
                    var testField = reportFields()[j];
                    if (testField.queryName === reportField.queryName) {
                        duplicated = true;
                    }
                }
            }
            if (duplicated) {
                reportField.designerVM.invalidMessage("Duplicated field.");
                reportField.designerVM.isValid(false);
                output = false;
            }

            if (!self.allowDuplicatedNames) {
                reportField.designerVM.duplicatedName(checkDuplicatedName(self, reportField));

                if (reportField.designerVM.duplicatedName()) {
                    reportField.designerVM.isValid(false);
                    reportField.designerVM.invalidMessage(reportField.designerVM.invalidMessage() + " Duplicated name.");
                    output = false;
                }
            }

            if (!reportField.displayName() || !reportField.displayName().trim()) {
                reportField.designerVM.isValid(false);
                reportField.designerVM.invalidMessage(reportField.designerVM.invalidMessage() + " Display name cannot be blank.");
                output = false;
            }

            if (reportField.isMetric && (reportField as MetricField).metricContainer.isExpression) {
                let metricField = (reportField as MetricField);
                let errorMessage = validateFormula(self, metricField.metricContainer.metricExpression.formulaTop, metricField.metricContainer.metricExpression.formulaBottom, reportField.groupingType(), true);
                if (errorMessage) {
                    reportField.designerVM.isValid(false);
                    reportField.designerVM.invalidMessage(reportField.designerVM.invalidMessage() + " " + errorMessage);
                    output = false;
                }
            }
        }

        return output;
    }
    
    function checkDuplicatedName(self: IViewModel, reportField: ReportField | MetricField) {
        var duplicate = false;

        if (checkDuplicatedNameOnList(reportField, self.fields)) {
            duplicate = true;
        }
        else {
            if (checkDuplicatedNameOnList(reportField, self.groups)) {
                duplicate = true;
            }
            else if (checkDuplicatedNameOnList(reportField, self.metrics)) {
                duplicate = true;
            }
        }
        return duplicate;
    }

    function checkDuplicatedNameOnList(reportField: ReportField | MetricField, list: KnockoutObservableArray<ReportField | MetricField>) {
        if (!list().find(x => x === reportField)) {//Don't validate on other lists, allow duplicate names but in different lists 
            return false;
        }

        if (list().find(x =>
            x.displayNameForDesigner() === reportField.displayNameForDesigner() &&
            x !== reportField &&
            (
                reportField.isMetric && (
                    (x.isMetric && (x as MetricField).metricContainer?.metric != (reportField as MetricField).metricContainer?.metric)
                    || !x.isMetric
                )
                ||
                !reportField.isMetric
            )
        )) {
            return true;
        }
        return false;
    }

    export const regexExpressionFormula = /\[(?<queryName>M(?<metric>\d+)_T(?<functionType>\d+)_C(?<comparisonType>\d+)_F(?<filterId>\d*))\]/g;
    export const regexExpressionFormulaNames = /\[(?<name>.+?)\]/g;

    export function validateFormulaForExpression(self: Ir.Components.ReportDesigner.ReportDesigner.IViewModel, formulaTop: string, formulaBottom: string, groupingType: GroupingTypeEnum, isDbFormula: boolean = false) {
        return validateFormula(self, formulaTop, formulaBottom, groupingType, isDbFormula);
    }

    function validateFormula(self: IViewModel, formulaTop: string, formulaBottom: string, groupingType: GroupingTypeEnum, isDbFormula: boolean = false) {
        let errorMessage = "";

        if (groupingType === GroupingTypeEnum.DSUM) {
            if (!formulaTop) {
                errorMessage = "Formula is empty";
            }
        }
        else {
            if (!formulaTop) {
                errorMessage = "Top Formula is empty";
            }
            else if (!formulaBottom) {
                errorMessage = "Bottom Formula is empty";
            }
        }

        if (!errorMessage) {
            let formulaReturn = getDbFormula(self, formulaTop, formulaBottom, groupingType, "(0)", isDbFormula);

            if (formulaReturn.formula) {
                if (formulaReturn.notFoundFields.length > 0) {
                    errorMessage = `Not found metrics: ${formulaReturn.notFoundFields.join(", ")}`;
                }
                try {
                    let result = eval(formulaReturn.formula.replace("=", "==="));
                    if (!isFinite(result) || isNaN(result)) {
                        throw new Error("Possible division by zero or not a number result.");
                    }
                }
                catch (error) {
                    if (errorMessage) {
                        errorMessage += "\n";
                    }
                    errorMessage += `Error evaluating expression: ${error}`;
                }

                if (!errorMessage) {
                    let completeFunction = function (data) {
                        errorMessage = data;
                    };
                    //Sync call
                    irGlobal.updateFromServer({},
                        urlConfigs.designer + "ValidateFormula",
                        { formula: formulaReturn.formula },
                        completeFunction,
                        function (textStatus, errorThrown, errorItem: IError) {
                            errorItem.userMessage = "Failed to validate formula"
                            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                        },
                        true, undefined, undefined, undefined, undefined, false);

                }
            }
        }
        return errorMessage;
    }

    let availableFields: Array<MetricField>; 
    function getDbFormula(self: IViewModel, formulaTop: string, formulaBottom: string, groupingType: GroupingTypeEnum, replaceValue: string, isDbFormula: boolean) {

        let formula = groupingType === GroupingTypeEnum.DSUM ? formulaTop : `IIF((${formulaBottom}) = 0, 0, (${formulaTop})/(${formulaBottom}))`;
        const matches = formula.matchAll(regexExpressionFormulaNames);
        let notFoundFields = [];

        //let availableFields: Array<MetricField> = isDbFormula ? getAvailableFields(self) : expressionBuilderVM.availableFields;
        //let availableFields: Array<MetricField>; 
        if (isDbFormula) {
            availableFields = getAvailableFields(self);
        }
        else {
            if (!availableFields) {
                availableFields = getAvailableFields(self);
            }
            console.log("REVIEW THIS CODE LATER");
        } 

        for (const match of matches) {
            let name = match.groups.name;
            let fieldExpression = !isDbFormula
                ? availableFields.find(x => x.displayNameForExpression === name)
                : availableFields.find(x => x.queryName === name);

            if (replaceValue === undefined) {
                let metricName = `[${fieldExpression.queryName}]`;
                formula = formula.replace(match[0], metricName);
            }
            else {
                if (!fieldExpression) {
                    notFoundFields.push(name);
                }
                formula = formula.replace(match[0], replaceValue);
            }
        }

        if (replaceValue === undefined) {
            return null;
        }
        else {
            return {
                formula,
                notFoundFields,
            }
        }
    }

    var filterVariables = getFilterVariables().map(x => x.id).join("|");
    var regexComparisonFilterVariables = `\\[(?<name>${filterVariables})\\]`;

    export function getAvailableFieldsForExpression(self: Ir.Components.ReportDesigner.ReportDesigner.IViewModel) {
        return getAvailableFields(self);
    }

    function getAvailableFields(self: IViewModel): Array<MetricField> {
        var availableFields: Array<MetricField> = [];
        if (self.reportConfig().reportType() === ReportTypeEnum.Analysis) {
            availableFields = self.fields().filter(x => x.isMetric && !(x as MetricField).metricContainer.isExpression) as Array<MetricField>;
        }
        else {
            availableFields = self.metrics().filter(x => !x.metricContainer.isExpression);
        }


        for (const field of availableFields) {

            //update display name to remove any [] and remove comparison filter variables 
            //concatenate the filter name in the name if it is not included yet to avoid duplicated names, which would cause problem in the formulas
            let foundComparisonFilterVariables = false;
            
            if (field.displayNameForDesigner().includes("[")) {

                const matches = field.displayNameForDesigner().matchAll(new RegExp(regexComparisonFilterVariables, 'gi'));

                for (const match of matches) {
                    foundComparisonFilterVariables = true;

                    let name = match.groups.name;
                    if (field.metricContainer.comparisonFilterId) {
                        let filter = self.comparisonFilters().find(x => x.id() === field.metricContainer.comparisonFilterId);
                        if (!field.displayNameForDesigner().includes(filter.name())) {
                            field.displayNameForExpression = field.displayNameForDesigner().replace(match[0], ``) + `(${filter.name()})`;
                        }
                        else {
                            field.displayNameForExpression = field.displayNameForDesigner().replace(match[0], ``).trim();
                        }
                    }
                    else {
                        field.displayNameForExpression = field.displayNameForDesigner().replace(match[0], ``).trim();
                    }
                }
            }

            if (!foundComparisonFilterVariables && field.metricContainer.comparisonFilterId) {
                let filter = self.comparisonFilters().find(x => x.id() === field.metricContainer.comparisonFilterId);
                if (!field.displayNameForDesigner().includes(filter.name())) {
                    field.displayNameForExpression = field.displayNameForDesigner() + ` (${filter.name})`;
                }
            }

            //replace any remain [] for () for the regex expression works
            field.displayNameForExpression = field.displayNameForExpression.replaceAll("[", "(");
            field.displayNameForExpression = field.displayNameForExpression.replaceAll("]", ")");
        }

        return availableFields;
    }

    function prepareDesigner(self: IViewModel) {
        //Set groupId zero in cases where groupId cannot be used
        if (self.widgetType() === WidgetType.Report || self.widgetType() === WidgetType.Chart) {
            for(let reportField of self.fields()) {
                reportField.groupId(0);
            }
        }

        //Set groupId zero in cases where groupId cannot be used
        if (self.widgetType() === WidgetType.Chart) {
            for(let reportField of self.groups()) {
                reportField.groupId(0);
            }
        }
    }

    export function hidePopovers() {        
        MappingService.hide();
        Ir.Components.ReportDesigner.ComparisonFilterFilters.hide();
    }

    export function addComparisonMetrics(metricField: MetricField, self: Ir.Components.ReportDesigner.ReportDesigner.IViewModel) {
        Ir.Components.ReportDesigner.ComparisonFilterList.addComparisonMetrics(metricField, self.widgetType(), self.metricArray(), self.comparisonFilters);
        onChanged(self);
    }

    let popoverMappingFieldsComponent: Ir.Components.Mapping.MappingTreePopover.IMappingPopover = null;
    function showMappingFields($target, self: IViewModel) {
        let config = {
            height: "70%",
            showButtonsInRow: true,
            fieldTitle: self.fieldsSectionName,
            addField: function (item) {
                if (item instanceof TableNameInputModel) {
                    let table = item as TableNameInputModel;
                    if (table.fields) {
                        for (let field of table.fields) {
                            self.addField(field);
                        }
                    }
                }
                else {
                    self.addField(item);
                }
            },
            groupTitle: self.groupSectionName,
            addGroup: function (item) {
                if (item instanceof TableNameInputModel) {
                    let table = item as TableNameInputModel;
                    if (table.fields) {
                        for (let field of table.fields) {
                            self.addGroup(field);
                        }
                    }
                }
                else {
                    self.addGroup(item);
                }
            },
            metricTitle: self.metricsSectionName,
            addMetric: function (item) {
                if (self.reportConfig().reportType() === ReportTypeEnum.Analysis) {
                    self.addField(item);
                }
                else {
                    self.addMetric(item);
                }
            }
        } as Ir.Components.Mapping.MappingTreePopover.IMappingOptions;

        let options = {
            type: self.openingByAdmin ? MappingPopoverTypeEnum.AllNonDerivedDates : MappingPopoverTypeEnum.All,
            $target: $target,
            onSelect(item: FieldNameInputModel) {
                if (item.metric) {
                    config.addMetric(item);
                }
                else {
                    config.addField(item);
                }
            },
            onSelectTable(fields: Array<FieldNameInputModel>) {
                for (let item of fields) {
                    if (item.metric) {
                        config.addMetric(item);
                    }
                    else {
                        config.addField(item);
                    }
                }
            },
            fieldDragTemplate(e, selectedItem: FieldNameInputModel) {
                let icon = selectedItem.metric ? "speed_1_2" : "abc";
                return $(`
        <div class="report-designer-field">
            <div class="field">
                <div class="field-type">
                    <span class="ms">${icon}</span>
                </div>
                <div class="field-name">
                    <span>${selectedItem.displayName}</span>
                </div>
            </div>
        </div>`);
            },
            keepItOpened: true,
            useOriginalName: self.reportConfig().isOriginalTemplate
        } as Ir.Components.Mapping.MappingTreePopover.IMappingPopoverOptions;

        if (popoverMappingFieldsComponent != null) {
            let component = popoverMappingFieldsComponent.getInstance();
            let element = component.element();
            component.dispose();
            element.remove();

            popoverMappingFieldsComponent = null;
        }

        let $popover = $(`<mapping-tree-popover params="callback: getComponent, config: config"></mapping-tree-popover>`);
        $popover.appendTo('body');
        ko.applyBindings({
            getComponent(component) {
                popoverMappingFieldsComponent = component;
                popoverMappingFieldsComponent.show(options);
            },
            config: config
        }, $popover[0]);

        return $popover;
    }
}